$(function () {
  formChange();
  contentCheck();
});

//==========================
// 回答や編集フォームの切り替え
//==========================
function formChange() {
  // 新規回答フォーム切り替え
  $(".js-answer-button").on("click", function () {
    targetObjects = $(".js-answer-button-form");
    for (let i = 0; i < targetObjects.length; i++) {
      targetObjects[i].style.display = "none";
    }
    document.getElementById("js-answer-form").style.display = "inline";
    // scroll処理の追加
    document.getElementById("js-answer-form").scrollIntoView({ behavior: "smooth" });
  });
  $(".js-answer-back-button").on("click", function () {
    targetObjects = $(".js-answer-button-form");
    for (let i = 0; i < targetObjects.length; i++) {
      targetObjects[i].style.display = "inline";
    }
    document.getElementById("js-answer-form").style.display = "none";
  });

  // 返信フォーム切り替え
  $(".js-new-reply-button").on("click", function () {
    var target = $(this);
    var childThreadId = target.data("target");
    changeFormAndButton("js-new-reply-form" + childThreadId, "js-new-reply-content" + childThreadId);
  });
  $(".js-new-reply-back-button").on("click", function () {
    var target = $(this);
    var childThreadId = target.data("target");
    changeFormAndButton("js-new-reply-content" + childThreadId, "js-new-reply-form" + childThreadId);
  });

  // 返信修正フォーム切り替え
  $(".js-reply-edit-button").on("click", function () {
    var target = $(this);
    var childThreadId = target.data("target");
    changeFormAndButton("js-edit-reply-form" + childThreadId, "js-reply-content" + childThreadId);
  });
  $(".js-reply-back-button").on("click", function () {
    var target = $(this);
    var childThreadId = target.data("target");
    changeFormAndButton("js-reply-content" + childThreadId, "js-edit-reply-form" + childThreadId);
  });
}

function changeFormAndButton(displayId, hiddenId) {
  document.getElementById(displayId).style.display = "inline";
  document.getElementById(hiddenId).style.display = "none";
}

//==========================
// 送信内容等のチェック処理
//==========================
function contentCheck() {
  // 新規返信
  $(".js-new-answer").on("click", function () {
    var target = $(this);
    var targetForm = $("#new_answer_form");
    var content = targetForm.find('[name="reply_content"]').val().replace(/\r?\n/g, "").replace(/\s/g, "");

    if (!content) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      $("#error_answer_content")[0].innerText = "回答内容を入力してください。";
      $("#modalAnswerSubmit").removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
    } else if (content.length > 1000) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      $("#error_answer_content")[0].innerText = "回答内容は1000文字以内で入力してください。";
      $("#modalAnswerSubmit").removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
    } else {
      targetForm.submit();
    }
  });

  // 新規返信
  $(".js-new-reply").on("click", function () {
    var target = $(this);
    var questionId = target.data("question");
    var threadId = target.data("thread");
    var isPap = target.data("pap");
    var targetForm = $("#create_new_reply_form" + threadId);
    var errorFlag = false;

    // 複数回施行時にエラー表示が残ったままになってしまうので、最初にリセットする
    targetForm.find(".input-textarea-front__input").removeClass("is-error");
    $("#error" + threadId)[0].innerText = "";
    if (!isPap) {
      targetForm.find(".input-text-front__input").removeClass("is-error");
      $("#error_mail" + threadId)[0].innerText = "";
    }

    var content = targetForm.find('[name="reply_content"]').val().replace(/\r?\n/g, "").replace(/\s/g, "");
    if (!content) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      $("#error" + threadId)[0].innerText = "返信内容を入力してください。";
      $("#modalReplySubmit" + threadId).removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
      errorFlag = true;
    } else if (content.length > 1000) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      $("#error" + threadId)[0].innerText = "返信内容は1000文字以内で入力してください。";
      $("#modalReplySubmit" + threadId).removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
      errorFlag = true;
    }

    if (isPap) {
      if (!errorFlag) {
        targetForm.submit();
      }
    } else {
      var mailAddress = targetForm.find('[name="mail_address"]').val();
      if (!mailAddress) {
        targetForm.find(".input-text-front__input").addClass("is-error");
        $("#error_mail" + threadId)[0].innerText = "メールアドレスを入力してください。";
        $("#modalReplySubmit" + threadId).removeClass("is-active");
        $(".js-overlay-bg").removeClass("is-active");
        htmlScroll();
      } else {
        $.ajax({
          type: "GET",
          url: "/questions/check_mail_address",
          dataType: "json",
          data: {
            id: questionId,
            mail_address: mailAddress
          }
        }).done(function (json) {
          if (!json.check) {
            targetForm.find(".input-text-front__input").addClass("is-error");
            $("#error_mail" + threadId)[0].innerText = json.alert_message;
            $("#modalReplySubmit" + threadId).removeClass("is-active");
            $(".js-overlay-bg").removeClass("is-active");
            htmlScroll();
          } else {
            if (!errorFlag) {
              targetForm.submit();
            }
          }
        });
      }
    }
  });

  // 返信内容修正
  $(".js-update-thread").on("click", function () {
    var target = $(this);
    var questionId = target.data("question");
    var childThreadId = target.data("child");
    var isPap = target.data("pap");
    var isFirstContent = target.data("first");
    var targetForm = $("#update_form" + childThreadId);
    var errorFlag = false;
    var messageError = targetForm.find(".js-error-message");
    var messageErrorMail = targetForm.find(".js-error-message-mail");

    // 複数回施行時にエラー表示が残ったままになってしまうので、最初にリセットする
    targetForm.find(".input-textarea-front__input").removeClass("is-error");
    messageError[0].innerText = "";
    if (!isPap) {
      targetForm.find(".input-text-front__input").removeClass("is-error");
      messageErrorMail[0].innerText = "";
    }

    var content = targetForm.find('[name="question_child_thread[reply_content]"]').val();
    content = content.replace(/\r?\n/g, "").replace(/\s/g, "");

    if (!content) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      if (isFirstContent) {
        messageError[0].innerText = "回答内容を入力してください。";
      } else {
        messageError[0].innerText = "返信内容を入力してください。";
      }
      $("#modalAnswerSubmit" + childThreadId).removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
      errorFlag = true;
    } else if (content.length > 1000) {
      targetForm.find(".input-textarea-front__input").addClass("is-error");
      if (isFirstContent) {
        messageError[0].innerText = "回答内容は1000文字以内で入力してください。";
      } else {
        messageError[0].innerText = "返信内容は1000文字以内で入力してください。";
      }
      $("#modalAnswerSubmit" + childThreadId).removeClass("is-active");
      $(".js-overlay-bg").removeClass("is-active");
      htmlScroll();
      errorFlag = true;
    }

    if (isPap) {
      if (!errorFlag) {
        targetForm.submit();
      }
    } else {
      var mailAddress = targetForm.find('[name="question_child_thread[mail_address]"]').val();
      if (!mailAddress) {
        targetForm.find(".input-text-front__input").addClass("is-error");
        messageErrorMail[0].innerText = "メールアドレスを入力してください。";
        $("#modalAnswerSubmit" + childThreadId).removeClass("is-active");
        $(".js-overlay-bg").removeClass("is-active");
        htmlScroll();
      } else {
        $.ajax({
          type: "GET",
          url: "/questions/check_mail_address",
          dataType: "json",
          data: {
            id: questionId,
            mail_address: mailAddress
          }
        }).done(function (json) {
          if (!json.check) {
            targetForm.find(".input-text-front__input").addClass("is-error");
            messageErrorMail[0].innerText = json.alert_message;
            $("#modalAnswerSubmit" + childThreadId).removeClass("is-active");
            $(".js-overlay-bg").removeClass("is-active");
            htmlScroll();
          } else {
            if (!errorFlag) {
              targetForm.submit();
            }
          }
        });
      }
    }
  });
}

function htmlScroll() {
  var st = parseFloat($("body").css("top")) * -1;
  $("html").removeClass("is-fixed").scrollTop(st);
  $("body").removeAttr("style");
}
